(function ($) {
  const lightbox = (params) => {
    // const dialog = $(`<div role="dialog"></div>`);
    // const content = $(`<div role="document"></div>`)
    //   .html(params.html)
    //   .appendTo(dialog);

    // const openDialog = () => {
    //   $("body").css({ overflowY: "hidden" });
    //   dialog
    //     .hide()
    //     .appendTo(document.body)
    //     .fadeIn(() => dialog.focus());
    // };

    // const closeDialog = () => {
    //   dialog.fadeOut(() => {
    //     dialog.remove();
    //     $("body").css({ overflowY: "auto" });
    //     params.onHide && params.onHide();
    //   });
    // };

    // dialog
    //   .css({
    //     position: "fixed",
    //     left: 0,
    //     top: 0,
    //     right: 0,
    //     bottom: 0,
    //     background: "#00000080",
    //     overflow: "auto",
    //     zIndex: 1040,
    //   })
    //   .on("click", () => closeDialog());
    // $(document).on(
    //   "keydown",
    //   (event) => event.key == "Escape" && dialog && closeDialog()
    // );

    // openDialog();
    // return;
    const modal =
      $(`<div class="modal fade mfa-our-team-modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                  </button>
                  &nbsp;
              </div>
              <div class="modal-body"></div>
          </div>
      </div>
  </div>`);
    modal.find(".modal-body").html(params.html);
    modal.hide().appendTo(document.body);
    modal.on("hidden.bs.modal", function () {
      modal.remove();
      params.onHide && params.onHide();
    });
    modal.modal("show");
  };

  $(".mfa-our-team_btn").each(function () {
    const button = $(this);
    button.on("click", function (e) {
      const item = button.parent();
      const desc = item.find(".mfa-our-team_description");
      lightbox({
        html: desc.html(),
        onHide: () => button.focus(),
      });
      e.preventDefault();
    });
  });
})(jQuery);
